import React from 'react';
import PropTypes from 'prop-types';
import {
  ActionButton,
} from '@makeably/creativex-design-system';

const propTypes = {
  isBusy: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onEvaluate: PropTypes.func.isRequired,
};

const defaultProps = {
  isBusy: false,
  isDisabled: false,
};

function ProcessControlControls({
  isBusy,
  isDisabled,
  onEvaluate,
}) {
  return (
    <div className="u-flexRow u-justifyEnd u-alignEnd u-gap-8">
      <ActionButton
        active={isBusy}
        disabled={isDisabled}
        label="Evaluate"
        onClick={onEvaluate}
      />
    </div>
  );
}

ProcessControlControls.propTypes = propTypes;
ProcessControlControls.defaultProps = defaultProps;

export default ProcessControlControls;
